"use client";

import { Core } from "@faire/design-tokens";
import { Row } from "@faire/web/slate/Layout";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { TypographyStyles } from "@faire/web/slate/Typography";
import * as React from "react";
import styled from "styled-components";

const linkColor = Core.text.subdued;
const linkHoverColor = Core.text.default;

const HoverChild = styled.div`
  display: none;
`;

const Item = styled(Row).attrs(() => ({ align: "center", justify: "center" }))`
  ${TypographyStyles({ as: undefined })};
  color: ${linkColor};
  height: 60px;
  padding: 0 12px;
  cursor: pointer;
  transition: color 0.1s linear;
  white-space: nowrap;

  &:hover {
    color: ${linkHoverColor};
  }

  ${responsiveMediaQueries.mobile} {
    height: 50px;
  }
`;

const ItemForFooter = styled(Item)`
  height: 30px;
  ${responsiveMediaQueries.mobile} {
    height: 40px;
  }
`;

const HoverItemContainer = styled.div`
  &:hover {
    ${HoverChild} {
      display: block;
    }
  }
`;

interface IProps {
  className?: string;
  hoverChild: React.ReactNode;
  position?: "top" | "bottom";
  "data-test-id"?: string;
  children?: React.ReactNode;
}

export const HoverItem = ({
  hoverChild,
  position,
  children,
  ...rest
}: IProps) => {
  const ItemWrapper = position === "top" ? ItemForFooter : Item;
  return (
    <HoverItemContainer {...rest}>
      <ItemWrapper>{children}</ItemWrapper>
      <HoverChild>{hoverChild}</HoverChild>
    </HoverItemContainer>
  );
};
